import { render } from "./SignUpButton.vue?vue&type=template&id=34c3d1a1&ts=true"
import script from "./SignUpButton.vue?vue&type=script&lang=ts"
export * from "./SignUpButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__